export { default as setHrefTarget } from "./links";
